import React, { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import TableE from "../components/ExpenseTable";
import TableS from "../components/SaleTable";
import TableC from "../components/CalculationTable";
import EPopup from "../components/expensePopup";
import SPopup from "../components/salesPopup";
import "reactjs-popup/dist/index.css";
import "../styling/sidebar.css";
import { Container, Row, Col } from "react-bootstrap";
import { useHistory, useLocation } from "react-router-dom";
import Popup from "reactjs-popup";
import AuthService from "../services/auth";
import UserService from "../services/user-service";
import PieChart from "../components/PieChart";
import AggregateLineChart from "../components/LineChart";
import SPieChart from "../components/Sales/SalesPieChart";
import SLineChart from "../components/Sales/SalesLineChartHover";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { ReactComponent as PlusIcon } from "../assets/sidebaricons/plusIcon.svg";
import { ReactComponent as CrossIcon } from "../assets/cross.svg";
import FormControl from "@mui/material/FormControl";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Alert from "react-bootstrap/Alert";
import ReactGA from "react-ga";
import "../styling/expense.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Calculators from "../components/Calculators";
import PopoverView from "../components/UI/PopoverView";
import { ArrowContainer } from "react-tiny-popover";
import { ReactComponent as ExcelImportIcon } from "../assets/excelImportIcon.svg";
import { ReactComponent as CsvImportIcon } from "../assets/csvImportIcon.svg";
import { ReactComponent as CloseIcon } from "../assets/cross.svg";
import { ReactComponent as HandIcon } from "../assets/handIcon.svg";
import cs from "classnames";
import CustomButton from "../components/UI/CustomButton/inedx";
import moment from "moment";
import SelectDropdown from "../components/UI/SelectDropdown";
import RCPopup from "../components/fileDataHandlers/readCsv";
import REPopup from "../components/fileDataHandlers/readExcel";
import Dropdown from "react-bootstrap/Dropdown";
import "bootstrap/dist/css/bootstrap.css";
import Mode from "../components/Mode";
import ReadSaleCsv from "../components/fileDataHandlers/readSaleCsv";
import ReadSaleExcel from "../components/fileDataHandlers/readSaleExcel";
import { platforms } from "../utils/PlatformTypes";
import { useMediaQuery } from '@mui/material';


interface CustomizedState {
  stream: number;
}

const theme = createTheme({
  palette: {
    primary: {
      main: "#48B7A7",
    },
    background: {
      paper: "#E8F9FD",
    },
  },
});

const eventTrackItem = (category, action, label) => {
  //console.log("GA event:", category, ":", action, ":", label);
  ReactGA.event({
    category: category,
    action: action,
    label: label,
  });
};

function IncomeStream() {
  ReactGA.pageview(window.location.pathname);
  const expensePercentageOptions = [
    {
      value: 0,
      label: "Category",
    },
    {
      value: 1,
      label: "Purchased From",
    },
    {
      value: 2,
      label: "Product Name",
    },
  ];
  const expenseTimeOptions = [
    {
      value: 0,
      label: "All Time",
    },
    {
      value: 1,
      label: "Last Week",
    },
    {
      value: 2,
      label: "Last Month",
    },
    {
      value: 3,
      label: "Last 60 Days",
    },
  ];

  const salesPercentageOptions = [
    {
      value: 0,
      label: "Product Category",
    },
    {
      value: 1,
      label: "Breakdown by item name",
    },
  ];

  const salesTimeOptions = [
    {
      value: 0,
      label: "All Time",
    },
    {
      value: 1,
      label: "Last Week",
    },
    {
      value: 2,
      label: "Last Month",
    },
    {
      value: 3,
      label: "Last 60 Days",
    },
  ];

  const eventTrackExpenseSales = (category, action, label) => {
    ReactGA.event({
      category: category,
      action: action,
      label: label,
    });
  };

  const location = useLocation();
  const history = useHistory();
  const _ = require("lodash");
  var statevars = location.state as CustomizedState;
  // 20-22 creates the state variables needed to hold information
  const [isLoading, setLoading] = useState(true);
  const [usource, setusource] = useState([]); //array type [], string type '', etc. in the call
  const [, setuincome] = useState([]);
  const [uname, setuname] = useState<any>([]);
  const [ucats, setucats] = useState([]);
  const [saleCategoryList, setSaleCategoryList] = useState([]);
  const [show, setShow] = useState(false);
  const [expense, setExpense] = useState(0);
  const [sale, setSale] = useState(0);
  const [expGraphOp, setExpGraphOp] = useState(1);
  const [saleGraphOp, setSaleGraphOp] = useState(2);
  const [expenseCategory, setExpenseCategory] = useState(0);
  const [salesFilter, setSalesFilter] = useState<Number>(0);
  const [expenseFilter, setExpenseFilter] = useState<Number>(0);
  const [expenseAlignment, setExpenseAlignment] = useState(1);
  const [salesAlignment, setSalesAlignment] = useState(2);
  const [sidebar, setSidebar] = useState(false);
  var reloadOption = String(sessionStorage.getItem("option"));
  const hintStep = localStorage.getItem("hintStep");
  const [activeModalStep, setActiveModalStep] = useState<any>();
  const [salesCategory, setSalesCategory] = useState(0);
  const [maxSalesProduct, setMaxSalesProduct] = useState<any>([]);
  const [maxExpenseProduct, setMaxExpenseProduct] = useState<any>([]);
  const [totalSoldItems, setTotalSoldItems] = useState(0);
  const [closeSaleAlert, setCloseSaleAlert] = useState(false);
  const [closeSaleSoldAlert, setCloseSaleSoldAlert] = useState(false);
  const [showExpenseModal, setShowExpenseModal] = useState(false);
  const [showSalesModal, setShowSalesModal] = useState(false);
  const [closeAlert, setCloseAlert] = useState(false);
  const [closeExpenseAlert, setCloseExpenseAlert] = useState(false);
  const [purchasedForm, setPurchasedForm] = useState([]);
  const [openCsvModal, setOpenCsvModal] = useState(false);
  const [openExcelModal, setOpenExcelModal] = useState(false);
  const [openSalesCsvModal, setOpenSalesCsvModal] = useState(false);
  const [openSalesExcelModal, setOpenSalesExcelModal] = useState(false);
  const [openEtsyPopup, setOpenEtsyPopup] = useState(true);
  const [openExpenseModal, setOpenExpenseModal] = useState(false);
  const [openSalesModal, setOpenSalesModal] = useState(false);
  const [reloadAPI,setReloadAPI] = useState(false);
  const [platformImage,setPlatformImage]=useState("")
  const options = ["sales", "expense", "saved"];
  const isMobile = useMediaQuery('(max-width:393px)');

  useEffect(() => {
    const etsyValue = localStorage.getItem("etsyPopup");
    if (etsyValue) {
      const value = JSON.parse(etsyValue);
      setOpenEtsyPopup(value.etsyPopup);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem(
      "etsyPopup",
      JSON.stringify({ etsyPopup: openEtsyPopup })
    );
  }, [openEtsyPopup]);

  useEffect(() => {
    setTimeout(() => {
      setActiveModalStep(hintStep);
    }, 500);
  }, []);

  useEffect(() => {
    localStorage.setItem("hintStep", activeModalStep);
  }, [activeModalStep]);

  if (!options.includes(reloadOption)) {
    reloadOption = "expense";
    sessionStorage.setItem("option", "expense");
  }
  const [option, setOption] = useState(reloadOption);

  useEffect(() => {
    sessionStorage.setItem("option", option);
    setReloadAPI((prevState)=>!prevState);
  }, [option]);

  useEffect(() => {
    option === "expense" &&
      UserService.onBoardingTaskExpCheck().then((response) => {
        setShowExpenseModal(!response.data.status);
      });
    option === "sales" &&
      UserService.onBoardingTaskSaleCheck().then((response) => {
        setShowSalesModal(!response.data.status);
      });
  }, [option, statevars?.stream]);

  useEffect(() => {
    
    if (isMobile) {
      history.push('/');
    }
  }, [isMobile]);

  const handleCloseModal = () => {
    setActiveModalStep("null");
  };

  function componentMounted() {
    const currUser = AuthService.getCurrentUser();
    if (!currUser) {
      history.push("/auth/login");
    }
    if (location.state) {
      sessionStorage.setItem("state", JSON.stringify(location.state));
    } else {
      const state = sessionStorage.getItem("state");
      if (state) {
        location.state = JSON.parse(state);
        statevars = JSON.parse(state);
      }
    }
    //this.setState({currUser:currUser, userReady:true})
  }
  componentMounted();

  function round_2(data) {
    var rounded = Number((Math.abs(data) * 100).toPrecision(15));
    return (Math.round(rounded) / 100) * Math.sign(rounded);
  }

  function allExpense(data) {
    var weeknumber: any = [
      moment().clone().startOf("week"),
      moment().clone().endOf("week"),
    ];
    const filterByWeek = data.filter((data) =>
      moment(data.date).isBetween(weeknumber[0]._d, weeknumber[1]._d)
    );
    let max_amount = _.maxBy(filterByWeek, "amount");
    setMaxExpenseProduct(max_amount);
    const totalExpense = round_2(
      data.reduce((total, obj) => obj.amount + total, 0)
    );
    setExpense(totalExpense);
  }

  function allSales(data) {
    var weeknumber: any = [
      moment().clone().startOf("week"),
      moment().clone().endOf("week"),
    ];
    const filterByWeek = data.filter((data) =>
      moment(data.date).isBetween(weeknumber[0]._d, weeknumber[1]._d)
    );
    setTotalSoldItems(filterByWeek.length);
    let max_amount = _.maxBy(filterByWeek, "amount");
    setMaxSalesProduct(max_amount);
    const totalSale = round_2(
      data.reduce((total, obj) => obj.amount + total, 0)
    );
    setSale(totalSale);
  }

  const handleExpensesGraph = (event) => {
    setExpenseCategory(event.target.value);
  };

  const handleSalesGraph = (event) => {
    setSalesCategory(event.target.value);
  };

  const handleOption = (event, newOption) => {
    if (newOption !== null) {
      eventTrackExpenseSales(
        "View Option For: " + uname[statevars?.stream],
        newOption,
        "Button"
      );
      setOption(newOption);
    }
  };

  const expenseGraphToggle = (e) => {
    setExpenseAlignment(Number(e.target.value));
    setExpGraphOp(Number(e.target.value));
    setExpenseCategory(0);
    setExpenseFilter(0);
  };

  const salesGraphToggle = (e) => {
    setSalesAlignment(Number(e.target.value));
    setSaleGraphOp(Number(e.target.value));
    setSalesCategory(0);
    setSalesFilter(0);
  };

  const displayGraph = () => {
    if (option === "expense" && expGraphOp === 1) {
      return (
        <PieChart
          className="piechart"
          stream={statevars?.stream}
          categoryType={
            expenseCategory === 0
              ? "category"
              : expenseCategory === 1
              ? "note"
              : expenseCategory === 2
              ? "name"
              : null
          }
          reloadAPI={reloadAPI}
        />
      );
    } else if (option === "expense" && expGraphOp === 2) {
      return (
        <AggregateLineChart
          stream={statevars?.stream}
          expenseFilter={expenseFilter}
          expenseAlignment={expGraphOp}
          reloadAPI={reloadAPI}
        />
      );
    } else if (option === "sales" && saleGraphOp === 1) {
      return (
        <SPieChart
          className="piechart"
          stream={statevars?.stream}
          categoryType={
            salesCategory === 0
              ? "category"
              : salesCategory === 1
              ? "item name"
              : null
          }
          reloadAPI={reloadAPI}
        />
      );
    } else if (option === "sales" && saleGraphOp === 2) {
      return (
        <SLineChart
          stream={statevars?.stream}
          salesFilter={salesFilter}
          salesAlignment={saleGraphOp}
          reloadAPI={reloadAPI}
        />
      );
    }
  };

  useEffect(() => {
    if (openSalesModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [openSalesModal]);

  useEffect(()=>{
    console.log("reload API incomestream page",reloadAPI)
    console.log('setOpenExpenseModal',openExpenseModal)
   },[reloadAPI])

  /*
  useEffect(() => {
		const token = localStorage.getItem('token');
    console.log(token);
    if (token) {
			const user = jwt_decode(token);
      console.log(user);
			if (!user) {
				localStorage.removeItem('token');
				history.replace('/auth/login');
			}
		}
  }, [])
*/
  // 43-50
  // sets the state variables and reloads the page once data is retrieved
  useEffect(() => {
    UserService.getIncome().then((response) => {
      setusource(response.data.source);
      setuincome(response.data.income);
      setuname(response.data.iname);
      setucats(response.data.categories);
    });
    UserService.getExpense().then((response) => {
      let purchased: any = [];
      const allExpenses = response.data.expense;
      allExpenses.map((item) => {
        if (!purchased.includes(item.site)) {
          purchased.push(item.site);
        }
      });
      setPurchasedForm(purchased);
      const filtered = UserService.getSpecificExpense(
        response.data.expense,
        statevars?.stream + 1
      );
      allExpense(filtered);
      setLoading(false);
    });
    UserService.getSale().then((response) => {
      const saleCategoryValues = response.data.sale.map((item) => item.note);
      setSaleCategoryList(
        saleCategoryValues.filter(
          (item, index) => saleCategoryValues.indexOf(item) === index
        )
      );
      const filtered = UserService.getSpecificExpense(
        response.data.sale,
        statevars?.stream + 1
      );
      allSales(filtered);
      setLoading(false);
    });
  }, [statevars?.stream,reloadAPI]);

  useEffect(() => {
    const platformImages=platforms.filter((item) => item.PlatformType === usource[statevars?.stream])
    if(platformImages.length>0){
     setPlatformImage(platformImages[0].PlatformTypeImg)
     }
     else{
     setPlatformImage("")
     }
 }, [usource]);

  //Simple loading page shown before info is retrived
  if (isLoading) {
    return <div className="App">Loading...</div>;
  }

  const handleEtsyStart = () => {
    history.push("/etsyShop");
  };

  const handleEtsyPopup = () => {
    setOpenEtsyPopup(false);
  };
  const handleCalc = () => {
    history.push({
      pathname: `${location.pathname}/calculator`,
      state: { ...statevars },
    });
  };

  if (show)
    return (
      <ThemeProvider theme={theme}>
        <Container fluid>
          <Row>
            <Sidebar
              sidebar={sidebar}
              setSidebar={setSidebar}
              setOption={setOption}
              reloadAPI={reloadAPI}
            />
            <Col
              className={
                sidebar
                  ? "sidebar-collapse-income-stream"
                  : "income-streams-container"
              }
            >
              <Calculators />
            </Col>
          </Row>
        </Container>
      </ThemeProvider>
    );
  

  return (
    <>
      <Popup open={showExpenseModal} onClose={() => setShowExpenseModal(false)}>
        <div className="mode">
          <button className="close" onClick={() => setShowExpenseModal(false)}>
            &times;
          </button>
          <div className="header"> Add Expense</div>
          <div className="content">
            <EPopup
              stream={statevars?.stream}
              purchasedData={purchasedForm}
              categories={ucats}  
              closeExpenseModal={setShowExpenseModal}
              setReloadAPI={setReloadAPI}
            />
            <br />
          </div>
        </div>
      </Popup>
      <Popup open={showSalesModal} onClose={() => setShowSalesModal(false)}>
        <div className="mode">
          <button className="close" onClick={() => setShowSalesModal(false)}>
            &times;
          </button>
          <div className="header"> Add Sales</div>
          <div className="content">
            <SPopup stream={statevars?.stream} 
            categories={saleCategoryList} 
            closeSaleModal ={setShowSalesModal} 
            setReloadAPI={setReloadAPI}
            />
            <br />
          </div>
        </div>
      </Popup>
      <Popup open={openCsvModal} closeOnDocumentClick={false}>
        <div className="mode">
          <button className="close" onClick={() => setOpenCsvModal(false)}>
            &times;
          </button>
          <div className="header"> Import CSV </div>
          <div className="content">
            {" "}
            <RCPopup stream={statevars?.stream} categories={ucats} setOpenCsvModal ={setOpenCsvModal} setReloadAPI={setReloadAPI}></RCPopup>
            <br />
          </div>
        </div>
      </Popup>
      <Popup open={openExcelModal} closeOnDocumentClick={false}>
        <div className="mode">
          <button className="close" onClick={() => setOpenExcelModal(false)}>
            &times;
          </button>
          <div className="header"> Import Excel </div>
          <div className="content">
            <REPopup stream={statevars?.stream} categories={ucats} setOpenExcelModal={setOpenExcelModal} setReloadAPI={setReloadAPI}></REPopup>
            <br />
          </div>
        </div>
      </Popup>
      <Popup
        open={openSalesCsvModal}
        closeOnDocumentClick={false}
      >
        <div className="mode">
          <button className="close" onClick={() => setOpenSalesCsvModal(false)}>
            &times;
          </button>
          <div className="header"> Import Sales CSV </div>
          <div className="content">
            <ReadSaleCsv stream={statevars?.stream} categories={ucats} setOpenSalesCsvModal={setOpenSalesCsvModal}  setReloadAPI={setReloadAPI}/>
            <br />
          </div>
        </div>
      </Popup>
      <Popup
        open={openSalesExcelModal}
        closeOnDocumentClick={false}
      >
        <div className="mode">
          <button
            className="close"
            onClick={() => setOpenSalesExcelModal(false)}
          >
            &times;
          </button>
          <div className="header"> Import Sales Excel </div>
          <div className="content">
            <ReadSaleExcel stream={statevars?.stream} categories={ucats} setOpenSalesExcelModal={setOpenSalesExcelModal} setReloadAPI={setReloadAPI} />
            <br />
          </div>
        </div>
      </Popup>

      <ThemeProvider theme={theme}>
        <Container fluid className="pl-0">
          <Row>
            <Sidebar
              sidebar={sidebar}
              setSidebar={setSidebar}
              setOption={setOption}
              reloadAPI={reloadAPI}
            />
            <Col
              className={
                sidebar
                  ? "sidebar-collapse-income-stream"
                  : "income-streams-container"
              }
            >
              <div className="d-flex justify-content-between">
                <div>
                  <Row>
                    <div className="income-stream-overview">
                      {uname[statevars?.stream]}
                    </div>
                  </Row>
                  <Row>
                    <div className="streamsource">
                      {platformImage ?
                            <img src={platformImage} alt={usource[statevars?.stream]} />:<p >{usource[statevars?.stream]}</p>}
                    </div>
                  </Row>
                  <Row>
                    <div>
                      <p className="total-expense">
                        Total Expenses:
                        <span className="text-secondary">
                          {" "}
                          $
                          {expense.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </span>
                      </p>
                    </div>
                  </Row>
                  <Row className="total-sale-row">
                    <div className="totalexpensesale">
                      <p className="total-expense">
                        Total Sales:
                        <span className="text-secondary">
                          {" "}
                          $
                          {sale.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </span>
                      </p>
                    </div>
                  </Row>
                </div>
                <div className="d-flex flex-column">
                  <Row>
                    <div className="d-flex align-items-center">
                      <div className="ml-3">
                        <Popup
                          trigger={
                            <button className="expensebutton ">
                              <PlusIcon />
                              <span className="bussiness-page-button">
                                {" "}
                                Add Expense
                              </span>
                            </button>
                          }
                          open={openExpenseModal}
                          modal
                          nested
                          onOpen={() => {
                            setOpenExpenseModal(true);
                          }}
                          onClose={() => setOpenExpenseModal(false)}
                          overlayStyle={{ height: "100vh", overflowY: "auto" }}
                        >
                          {(close) => (
                            <div className="mode">
                              <button className="close" onClick={close}>
                                &times;
                              </button>
                              <div className="header"> Add Expense</div>
                              <div className="content">
                                <EPopup
                                  stream={statevars?.stream}
                                  purchasedData={purchasedForm}
                                  categories={ucats}
                                  closeExpenseModal ={setOpenExpenseModal} 
                                  setReloadAPI={setReloadAPI}
                                />
                                <br />
                              </div>
                            </div>
                          )}
                        </Popup>

                        <Popup
                          trigger={
                            <button className="expensebutton ">
                              <PlusIcon />
                              <span className="bussiness-page-button">
                                {" "}
                                Add Sales
                              </span>
                            </button>
                          }
                          open={openSalesModal}
                          modal
                          nested
                          onOpen={() => {
                            setOpenSalesModal(true);
                          }}
                          onClose={() => setOpenSalesModal(false)}
                          overlayStyle={{
                            height: "100vh",
                            overflowY: "auto",
                          }}
                        >
                          {(close) => (
                            <div className="mode">
                              <button className="close" onClick={close}>
                                &times;
                              </button>
                              <div className="header"> Add Sales</div>
                              <div className="content">
                                <SPopup
                                  stream={statevars?.stream}
                                  categories={saleCategoryList}
                                  closeSaleModal ={setOpenSalesModal} 
                                  setReloadAPI={setReloadAPI}
                                />
                                <br />
                              </div>
                            </div>
                          )}
                        </Popup>
                        <button className="expensebutton " onClick={handleCalc}>
                          <PlusIcon />
                          <span className="bussiness-page-button ml-1">
                            Calculate Pricing
                          </span>
                        </button>
                      </div>
                    </div>
                  </Row>
                  <Row className="d-flex justify-content-start ml-0">
                    <div className="excel-csv-dropdown ml-3">
                      <Dropdown>
                        <Dropdown.Toggle
                          style={{
                            borderRadius: "6px",
                            boxShadow: "0 0 40px rgb(0 0 0 / 0%)",
                          }}
                        >
                          Import Expenses
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item onClick={() => setOpenCsvModal(true)}>
                            <CsvImportIcon />
                            Import from CSV
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => setOpenExcelModal(true)}
                          >
                            <ExcelImportIcon />
                            Import from XLS
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <div className="excel-csv-dropdown ml-3">
                      <Dropdown>
                        <Dropdown.Toggle
                          style={{
                            borderRadius: "6px",
                            boxShadow: "0 0 40px rgb(0 0 0 / 0%)",
                          }}
                        >
                          Import Sales
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => setOpenSalesCsvModal(true)}
                          >
                            <CsvImportIcon />
                            Import from CSV
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => setOpenSalesExcelModal(true)}
                          >
                            <ExcelImportIcon />
                            Import from XLS
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </Row>
                </div>
              </div>
              {openEtsyPopup &&
                (usource[statevars?.stream] === "Etsy" ||
                  usource[statevars?.stream] === "etsy") && (
                  <div
                    className={
                      sidebar
                        ? "etsy-banner-sidebar-collapse mb-5 ml-3"
                        : "etsy-banner mb-5 ml-3"
                    }
                  >
                    <div className="etsy-logo" />
                    <div>
                      <p className="etsy-text">
                        Connect {uname[statevars?.stream]} to Etsy to
                        automatically import all your past sales into your sales
                        log
                      </p>
                    </div>
                    <div className="d-flex etsy-btnwrapper">
                    <button
                      className="etsy-start-button"
                      onClick={handleEtsyStart}
                    >
                      Get Started
                    </button>
                    <button
                      className="etsy-not-show-button"
                      onClick={handleEtsyPopup}
                    >
                      Don't show again
                    </button>
                    </div>
                   
                  </div>
                )}
              <Row className="d-flex justify-content-between">
                {totalSoldItems > 0 && !closeSaleAlert && (
                  <div>
                    <Alert
                      key="success"
                      variant="success"
                      className={
                        sidebar ? "alert-sidebar-collapse" : "alert-box"
                      }
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <HandIcon className="hand-icon" />
                        </div>
                        <div className="ml-2">
                          You sold {totalSoldItems} items
                        </div>
                        <div>
                          <CrossIcon
                            className="mb-3 alert-cross-icon"
                            onClick={() => setCloseSaleAlert(true)}
                          />
                        </div>
                      </div>
                    </Alert>
                  </div>
                )}
                <div>
                  {!closeAlert && (
                    <Alert
                      key="success"
                      variant="success"
                      className={
                        sidebar ? "alert-sidebar-collapse" : "alert-box"
                      }
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <HandIcon className="hand-icon" />
                        </div>
                        <div className="ml-2">
                          {maxSalesProduct ? (
                            <p>
                              <span
                                style={{
                                  textDecoration: "underline",
                                  fontWeight: "bold",
                                }}
                              >
                                {maxSalesProduct.name}
                              </span>{" "}
                              was your top selling product{" "}
                            </p>
                          ) : (
                            "You had no sales this week"
                          )}
                        </div>
                        <div>
                          <CrossIcon
                            className="mb-3 alert-cross-icon"
                            onClick={() => setCloseAlert(true)}
                          />
                        </div>
                      </div>
                    </Alert>
                  )}
                </div>
                {!closeExpenseAlert && (
                  <div>
                    <Alert
                      key="danger"
                      variant="danger"
                      className={
                        sidebar ? "alert-sidebar-collapse" : "alert-box"
                      }
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <HandIcon className="hand-icon" />
                        </div>
                        <div className="ml-2">
                          {maxExpenseProduct ? (
                            <p>
                              <span
                                style={{
                                  textDecoration: "underline",
                                  fontWeight: "bold",
                                }}
                              >
                                {maxExpenseProduct.name}
                              </span>{" "}
                              was your biggest source of expenses this week
                            </p>
                          ) : (
                            "No expenses in this week"
                          )}{" "}
                        </div>
                        <div>
                          <CrossIcon
                            className="mb-3 alert-cross-icon"
                            onClick={() => setCloseExpenseAlert(true)}
                          />
                        </div>
                      </div>
                    </Alert>
                  </div>
                )}
              </Row>
              <Row>
                <Tabs
                  value={option}
                  onChange={handleOption}
                  sx={{ marginLeft: 5, marginBottom: 4 }}
                  className="income-stream-tabs"
                >
                  <Tab
                    label="Expense Tracker"
                    value="expense"
                    className="all-tabs"
                    sx={{
                      fontWeight: 600,
                      textTransform: "capitalize",
                      fontSize: 18,
                    }}
                  />
                  <Tab
                    label="Sales Log"
                    value="sales"
                    className="all-tabs"
                    sx={{
                      fontWeight: 600,
                      textTransform: "capitalize",
                      fontSize: 18,
                    }}
                  />
                  <Tab
                    label="Saved Pricing Calculations"
                    value="saved"
                    className="all-tabs"
                    sx={{
                      fontWeight: 600,
                      textTransform: "capitalize",
                      fontSize: 18,
                    }}
                  />
                </Tabs>
              </Row>
              {option !== "saved" && (
                <div
                  className={`mb-5 ml-3 ${
                    sidebar ? `piechart-section-sidebar` : `piechart-section `
                  }`}
                >
                  {option == "expense" && (
                    <Row
                      className={`d-flex ${
                        option == "expense" && expenseAlignment == 1
                          ? `expense-piechart-actions`
                          : `toggle-btn-section`
                      }`}
                    >
                      <div className="mt-3">
                        {option == "expense" && (
                          <>
                            <div className="d-flex flex-wrap">
                              <PopoverView
                                isOpen={activeModalStep === "4"}
                                positions={["top"]}
                                parentElement={document.getElementById(
                                  "expense"
                                )}
                                content={({
                                  position,
                                  childRect,
                                  popoverRect,
                                }) => (
                                  <ArrowContainer // if you'd like an arrow, you can import the ArrowContainer!
                                    position={position}
                                    popoverRect={popoverRect}
                                    arrowColor={"#41c175"}
                                    arrowSize={10}
                                    arrowStyle={{ opacity: 0.7 }}
                                    childRect={childRect}
                                    arrowClassName="arrow-wrapper-right"
                                  >
                                    <div className="position-relative popover-wrapper">
                                      <div className="d-flex justify-content-end">
                                        <CloseIcon
                                          className={cs("closeIcon")}
                                          style={{ fill: "#fff" }}
                                          onClick={handleCloseModal}
                                        />
                                      </div>
                                      <div className="">
                                        You can see general analytics and
                                        percent changes for your individual
                                        income stream.
                                      </div>
                                      <div className="d-flex justify-content-between align-items-center">
                                        <div className="dot-list-wrapper">
                                          {[1, 2, 3, 4, 5, 6].map((list) => (
                                            <div
                                              key={list}
                                              className={cs("dots", {
                                                ["active-dots"]:
                                                  list <= +activeModalStep,
                                              })}
                                            />
                                          ))}
                                        </div>

                                        <CustomButton
                                          className="start-btn mt-0 mb-0"
                                          onClick={() => {
                                            setActiveModalStep("5");
                                            setOption("saved");
                                          }}
                                        >
                                          Next
                                        </CustomButton>
                                      </div>
                                    </div>
                                  </ArrowContainer>
                                )}
                              >
                                <FormControl className="justify-content-center">
                                  <RadioGroup
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    value={expenseAlignment}
                                    name="row-radio-buttons-group"
                                    onChange={expenseGraphToggle}
                                  >
                                    <FormControlLabel
                                      value={1}
                                      className="mb-1 radio-btn"
                                      control={<Radio />}
                                      onClick={() => {
                                        eventTrackItem(
                                          "Graph Option",
                                          "Exp Percent Breakdown",
                                          "Button"
                                        );
                                      }}
                                      label="Percentage Breakdown"
                                    />
                                    <FormControlLabel
                                      value={2}
                                      className="mb-0 mt-1 radio-btn"
                                      control={<Radio />}
                                      onClick={() => {
                                        eventTrackItem(
                                          "Graph Option",
                                          "Exp Time Breakdown",
                                          "Button"
                                        );
                                      }}
                                      label="Time Breakdown"
                                    />
                                  </RadioGroup>
                                </FormControl>
                              </PopoverView>
                              <div className="d-flex flex-column">
                                <div className="my-1">
                                  <SelectDropdown
                                    label="Pie Chart Type"
                                    width={200}
                                    value={expenseCategory}
                                    options={expensePercentageOptions}
                                    isDisable={expenseAlignment !== 1}
                                    onChange={handleExpensesGraph}
                                  />
                                </div>
                                <div className="my-1">
                                  <SelectDropdown
                                    label="Expense Filter"
                                    width={200}
                                    value={expenseFilter}
                                    options={expenseTimeOptions}
                                    isDisable={expenseAlignment !== 2}
                                    onChange={(e) =>
                                      setExpenseFilter(e.target.value)
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </Row>
                  )}
                  {option === "sales" && (
                    <Row
                      className={`d-flex ${
                        option === "sales" && salesAlignment === 1
                          ? `sales-piechart-actions`
                          : `toggle-btn-section`
                      }`}
                    >
                      <div className="mt-3">
                        {option === "sales" && (
                          <Row>
                            <Col id="sales">
                              <div className="d-flex">
                                <PopoverView
                                  isOpen={activeModalStep === "4"}
                                  positions={["top"]}
                                  parentElement={document.getElementById(
                                    "sales"
                                  )}
                                  content={({
                                    position,
                                    childRect,
                                    popoverRect,
                                  }) => (
                                    <ArrowContainer // if you'd like an arrow, you can import the ArrowContainer!
                                      position={position}
                                      popoverRect={popoverRect}
                                      arrowColor={"#41c175"}
                                      arrowSize={10}
                                      arrowStyle={{ opacity: 0.7 }}
                                      childRect={childRect}
                                      arrowClassName="arrow-wrapper-right"
                                    >
                                      <div className="position-relative popover-wrapper">
                                        <div className="d-flex justify-content-end">
                                          <CloseIcon
                                            className={cs("closeIcon")}
                                            style={{ fill: "#fff" }}
                                            onClick={handleCloseModal}
                                          />
                                        </div>
                                        <div className="">
                                          You can see general analytics and
                                          percent changes for your individual
                                          income stream.
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center">
                                          <div className="dot-list-wrapper">
                                            {[1, 2, 3, 4, 5, 6].map((list) => (
                                              <div
                                                key={list}
                                                className={cs("dots", {
                                                  ["active-dots"]:
                                                    list <= +activeModalStep,
                                                })}
                                              />
                                            ))}
                                          </div>

                                          <CustomButton
                                            className="start-btn mt-0 mb-0"
                                            onClick={() => {
                                              setActiveModalStep("5");
                                              setOption("saved");
                                            }}
                                          >
                                            Next
                                          </CustomButton>
                                        </div>
                                      </div>
                                    </ArrowContainer>
                                  )}
                                >
                                  <FormControl className="justify-content-center">
                                    <RadioGroup
                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                      value={salesAlignment}
                                      name="row-radio-buttons-group"
                                      onChange={salesGraphToggle}
                                    >
                                      <FormControlLabel
                                        value={1}
                                        className="mb-1 radio-btn"
                                        control={<Radio />}
                                        onClick={() => {
                                          eventTrackItem(
                                            "Graph Option",
                                            "Sales Percent Breakdown",
                                            "Button"
                                          );
                                        }}
                                        label="Percentage Breakdown"
                                      />
                                      <FormControlLabel
                                        value={2}
                                        className="mb-0 mt-1 radio-btn"
                                        control={<Radio />}
                                        onClick={() => {
                                          eventTrackItem(
                                            "Graph Option",
                                            "Sales Time Breakdown",
                                            "Button"
                                          );
                                        }}
                                        label="Time Breakdown"
                                      />
                                    </RadioGroup>
                                  </FormControl>
                                </PopoverView>
                                <div className="d-flex flex-column">
                                  <div className="my-1">
                                    <SelectDropdown
                                      label="Pie Chart Type"
                                      width={200}
                                      value={salesCategory}
                                      options={salesPercentageOptions}
                                      isDisable={salesAlignment !== 1}
                                      onChange={handleSalesGraph}
                                    />
                                  </div>
                                  <div className="my-1">
                                    <SelectDropdown
                                      label="Sales Filter"
                                      width={200}
                                      value={salesFilter}
                                      options={salesTimeOptions}
                                      isDisable={salesAlignment !== 2}
                                      onChange={(e) =>
                                        setSalesFilter(e.target.value)
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        )}
                      </div>
                    </Row>
                  )}
                  <Row className="my-4">
                    <Col>{displayGraph()}</Col>
                  </Row>
                </div>
              )}
              <Row className="mb-5 pb-4">
                {option === "expense" && (
                  <div className={sidebar ? "streams-sidebar" : "streams"}>
                    <TableE
                      stream={statevars?.stream}
                      categories={ucats}
                      sideBar={sidebar}
                      reloadAPI={reloadAPI}
                      setReloadAPI={setReloadAPI}
                    />
                  </div>
                )}
                {option === "sales" && (
                  <div className={sidebar ? "streams-sidebar" : "streams"}>
                    <TableS
                      stream={statevars?.stream}
                      categories={ucats}
                      sideBar={sidebar}
                      reloadAPI={reloadAPI}
                      setReloadAPI={setReloadAPI}
                    />
                  </div>
                )}
                {option === "saved" && (
                  <div className={sidebar ? "streams-sidebar" : "streams"}>
                    <TableC
                      stream={statevars?.stream}
                      activeModalStep={activeModalStep}
                      handleCloseModal={handleCloseModal}
                      setActiveModalStep={setActiveModalStep}
                    />
                  </div>
                )}
              </Row>
            </Col>
          </Row>
        </Container>
      </ThemeProvider>
      <Mode />
    </>
  );
}

export default IncomeStream;
